import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import MapView from 'components/MapView'
import LoadingBubbles from 'components/LoadingBubbles'
import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'

 
const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
  },
  loading: {
    display: 'block',
    position: 'absolute',
    top: '40%',
    left: '40%',
    width: '25%',
    height: '25%',
    margin: 'auto',
  },
}))

//  The MapView component is expecting data in the form of:
//  {
//      "AL": 5,
//      "PA": 8,
//      ...
//  }
const normalize = (stateStats) =>
  stateStats.reduce(
    (previous, current) => ({
      ...previous,
      [current.state]: current.count,
    }),
    {},
  )

const Map = ({ loading, stateStats, onSelectState }) => {
  const normalizedStateStats = useMemo(() => (!loading && normalize(stateStats)) || {}, [loading, stateStats])
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <MapView
        stats={normalizedStateStats}
        onSelectState={onSelectState}
      />
      {loading && <LoadingBubbles className={classes.loading} />}
    </Box>
  )
}

Map.propTypes = {
  loading: PropTypes.bool.isRequired,
  stateStats: PropTypes.arrayOf(
    PropTypes.shape({
      state: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
    }),
  ).isRequired,
  onSelectState: PropTypes.func.isRequired,
}

export default Map
